import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import i18next, { mergeCustomI18n } from '@risksmart-app/i18n/src/i18n';
import type { FC, ReactNode } from 'react';
import { createContext } from 'react';
import Loading from 'src/components/loading';
import { useGetTaxonomyByLocale } from 'src/hooks/queries';

type ITaxonomyContext = {
  loading: boolean;
};

const TaxonomyContext = createContext<null | ITaxonomyContext>(null);

const TaxonomyProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { user } = useRisksmartUser();
  const orgKey = user?.orgKey;

  const { data, loading } = useGetTaxonomyByLocale({
    queryArgs: { locale: i18next.language, orgKey: orgKey ?? '' },
    shouldSkip: !orgKey,
  });

  mergeCustomI18n(data?.taxonomy_org[0]?.taxonomy);

  return (
    <TaxonomyContext.Provider
      value={{
        loading,
      }}
    >
      {loading ? <Loading data-loading-reason={'taxonomy'} /> : children}
    </TaxonomyContext.Provider>
  );
};

export { TaxonomyProvider };
